import { css } from 'styled-components';
import { getColorAlias } from '../../utils/index.js';

/**
 * Use this function to define the base and highlight colors for Skeleton component.
 * @param {AliasKey} baseKey - Alias to get the base color
 * @param {AliasKey} highlightKey - Alias to get the highlight color
 * @returns {CSS} - CSS background properties
 */
const getSkeletonColors = (baseKey, highlightKey) => {
    const baseColor = getColorAlias(baseKey);
    const highlightColor = getColorAlias(highlightKey);
    return css `
    background-color: ${baseColor};
    background-image: linear-gradient(
      90deg,
      ${baseColor},
      ${highlightColor},
      ${baseColor}
    );
    background-size: 200px 100%;
    background-repeat: no-repeat;
  `;
};
/**
 * Use this function to define the dimensions for Skeleton component.
 * @param {SkeletonProps} props - Skeleton properties
 * @returns {CSS} - CSS height and width properties
 */
const getSkeletonDimensions = (props) => {
    var _a, _b, _c, _d;
    let skeletonHeight;
    switch (props.variant) {
        case 'area':
            skeletonHeight = props.large ? '105px' : '20px';
            break;
        case 'body':
            skeletonHeight = '8px';
            break;
        case 'button':
            skeletonHeight = '42px';
            break;
        case 'chip':
            skeletonHeight = '30px';
            break;
        case 'heading':
            skeletonHeight = '20px';
            break;
        case 'image':
            skeletonHeight = '105px';
            break;
        case 'thumbnail':
            skeletonHeight = (_b = (_a = props.height) !== null && _a !== void 0 ? _a : props.width) !== null && _b !== void 0 ? _b : '50px';
            break;
        case 'text-input':
        default:
            skeletonHeight = '40px';
            break;
    }
    return css `
    height: ${(_c = props.height) !== null && _c !== void 0 ? _c : skeletonHeight};
    width: ${(_d = props.width) !== null && _d !== void 0 ? _d : '100%'};
  `;
};
/**
 * Use this function to define the height for the Skeleton component.
 * @param {SkeletonProps} variant - Skeleton variants
 * @param {boolean} circle - Boolean to define if the radius value should be theme.radius.roundedE
 * @param {Theme} theme - Skeleton properties
 * @returns {CSS} - CSS border radius with the value
 */
const getSkeletonRadius = (variant, circle = false, theme) => {
    let radius = theme.radius.roundedA;
    if (variant === 'chip')
        radius = theme.radius.roundedD;
    else if (circle)
        radius = theme.radius.roundedE;
    return css `
    border-radius: ${radius};
  `;
};

export { getSkeletonColors, getSkeletonDimensions, getSkeletonRadius };
